import { render, staticRenderFns } from "./PedidoDeCompraCriarFollowUpView.vue?vue&type=template&id=d8a8d370&scoped=true"
import script from "./PedidoDeCompraCriarFollowUpView.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoDeCompraCriarFollowUpView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PedidoDeCompraCriarFollowUpView.vue?vue&type=style&index=0&id=d8a8d370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a8d370",
  null
  
)

export default component.exports